import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import HomePage from './HomePage';

const styles = {
  body: { fontFamily: "'Segoe UI', Arial, sans-serif", margin: 0, background: '#f8f9fa' },
  header: { background: '#fff', boxShadow: '0 2px 8px #eee', padding: '0 40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  logo: { height: '160px', marginRight: '32px' },
  navList: { listStyle: 'none', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', margin: 0, padding: 0 },
  navItem: { position: 'relative', margin: '0 18px' },
  navLink: { color: '#222', textDecoration: 'none', fontWeight: '600', padding: '18px 14px', display: 'block', fontSize: '18px', borderRadius: '6px', transition: 'background 0.2s, color 0.2s', cursor: 'pointer' },
  dropdownContent: { position: 'absolute', background: '#fff', minWidth: '220px', boxShadow: '0 8px 32px rgba(0,0,0,0.13)', zIndex: 100, left: 0, top: '110%', borderRadius: '12px', padding: '12px 0' },
  dropdownLink: { color: '#222', padding: '14px 22px', textDecoration: 'none', display: 'block', fontSize: '17px', borderRadius: '6px', transition: 'background 0.2s, color 0.2s' },
  hero: { background: 'linear-gradient(90deg, #0078d7 60%, #e0f0ff 100%)', color: '#fff', padding: '20px 20px 40px 20px', textAlign: 'center' },
  heroImg: { width: '320px', marginTop: '20px', borderRadius: '12px', boxShadow: '0 4px 16px rgba(0,0,0,0.13)', display: 'block', marginLeft: 'auto', marginRight: 'auto' },
  ctaBtn: { marginTop: '40px', padding: '14px 36px', background: '#fff', color: '#0078d7', border: 'none', borderRadius: '6px', fontSize: '20px', fontWeight: 'bold', cursor: 'pointer', display: 'block', marginLeft: 'auto', marginRight: 'auto' },
  productsSection: { display: 'flex', justifyContent: 'space-around', margin: '60px 0 40px 0' },
  productCard: { background: '#fff', borderRadius: '12px', boxShadow: '0 2px 12px #ccc', padding: '32px 20px', width: '30%', textAlign: 'center', transition: 'transform 0.2s' },
  productIcon: { fontSize: '48px', color: '#0078d7', marginBottom: '18px' },
  productImg: { width: '100%', maxWidth: '180px', borderRadius: '8px', marginBottom: '16px' },
  productBtn: { marginTop: '16px', padding: '10px 28px', background: '#0078d7', color: '#fff', border: 'none', borderRadius: '4px', fontSize: '16px', cursor: 'pointer' },
  featuresSection: { background: '#e0f0ff', padding: '40px 20px' },
  featuresList: { display: 'flex', justifyContent: 'space-around' },
  featuresUl: { listStyle: 'none', padding: 0 },
  featuresLi: { marginBottom: '12px', fontSize: '18px' },
  howSection: { padding: '40px 20px', textAlign: 'center' },
  steps: { display: 'flex', justifyContent: 'center', gap: '40px', marginTop: '24px' },
  step: { background: '#fff', borderRadius: '8px', boxShadow: '0 2px 8px #ccc', padding: '24px', width: '220px' },
  stepIcon: { fontSize: '36px', color: '#0078d7', marginBottom: '10px' },
  footer: { background: '#222', color: '#fff', textAlign: 'center', padding: '24px 0', marginTop: '40px' },
};

const dropdowns = {
  products: [
    { label: 'School Management', showHome: true },
    { label: 'NABL Accreditation', href: '#nabl-accreditation' },
    { label: 'Herbalife', href: '#herbalife' },
  ],
  resources: [
    { label: 'Help Center', href: '#help' },
    { label: 'Documentation', href: '#docs' },
    { label: 'Video Tutorials', href: '#videos' },
    { label: 'Contact Us', href: '#contact' },
    { label: 'Request Demo', href: '#demo' },
  ],
  company: [
    { label: 'About Us', href: '#about' },
    { label: 'Mission', href: '#mission' },
    { label: 'Vision', href: '#vision' },
    { label: 'Innovation', href: '#innovation' },
    { label: 'Careers', href: '#careers' },
  ],
};

function AstravisionDemo() {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [showHomePage, setShowHomePage] = useState(false);
  const navigate = useNavigate();
  const navRef = useRef(null);

  const toggleDropdown = (name) => setOpenDropdown(openDropdown === name ? null : name);

  // Close dropdown when clicking outside the navbar
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  if (showHomePage) {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    document.documentElement.scrollTop = 0;
    return <HomePage onLogoClick={() => setShowHomePage(false)} />;
  }

  return (
    <div style={styles.body}>
      {/* Header */}
      <header style={styles.header}>
        <img src="/AstraVision_Logo.png" alt="Astravision Logo" style={{...styles.logo, cursor: 'pointer'}} onClick={() => { window.location.href = '/'; }} />
        <nav style={{ width: '100%' }} ref={navRef}>
          <ul style={styles.navList}>
            <li style={styles.navItem}><a href="#home" style={styles.navLink}>Home</a></li>

            {/* Products dropdown */}
            <li style={styles.navItem}>
              <a href="#products"
                style={{ ...styles.navLink, color: openDropdown === 'products' ? '#0078d7' : '#222' }}
                onClick={(e) => { e.preventDefault(); toggleDropdown('products'); }}>
                Products <i className="fas fa-caret-down"></i>
              </a>
              {openDropdown === 'products' && (
                <ul style={{ ...styles.dropdownContent, listStyle: 'none', padding: '8px 0', margin: 0 }}>
                  {dropdowns.products.map(item => (
                    <li key={item.label}>
                      {item.showHome
                        ? <button
                            style={{ ...styles.dropdownLink, color: hoveredItem === `products-${item.label}` ? '#fff' : '#222', background: hoveredItem === `products-${item.label}` ? '#0078d7' : 'transparent', borderRadius: '6px', margin: '0 8px', padding: '12px 16px', border: 'none', width: '100%', textAlign: 'left', cursor: 'pointer', fontSize: '17px', display: 'flex', alignItems: 'center', gap: '8px' }}
                            onMouseEnter={() => setHoveredItem(`products-${item.label}`)}
                            onMouseLeave={() => setHoveredItem(null)}
                            onClick={(e) => { e.preventDefault(); navigate('/school-management'); setOpenDropdown(null); }}>
                            <img src="/absloute-logo.jpeg" alt="AbsoluteVision Logo" style={{ width: '24px', height: '24px', objectFit: 'contain', borderRadius: '4px' }} />
                            {item.label}
                          </button>
                        : <a
                            href={item.href}
                            style={{ ...styles.dropdownLink, color: hoveredItem === `products-${item.label}` ? '#fff' : '#222', background: hoveredItem === `products-${item.label}` ? '#0078d7' : 'transparent', borderRadius: '6px', margin: '0 8px', padding: '12px 16px', display: 'block', fontSize: '17px' }}
                            onMouseEnter={() => setHoveredItem(`products-${item.label}`)}
                            onMouseLeave={() => setHoveredItem(null)}
                          >{item.label}</a>
                      }
                    </li>
                  ))}
                </ul>
              )}
            </li>

            <li style={styles.navItem}><a href="#solutions" style={styles.navLink}>Solutions</a></li>

            {/* Resources dropdown */}
            <li style={styles.navItem}>
              <a href="#resources"
                style={{ ...styles.navLink, color: openDropdown === 'resources' ? '#0078d7' : '#222' }}
                onClick={(e) => { e.preventDefault(); toggleDropdown('resources'); }}>
                Resources <i className="fas fa-caret-down"></i>
              </a>
              {openDropdown === 'resources' && (
                <ul style={{ ...styles.dropdownContent, listStyle: 'none', padding: '8px 0', margin: 0 }}>
                  {dropdowns.resources.map(item => (
                    <li key={item.label}>
                      <a href={item.href}
                        style={{ ...styles.dropdownLink, color: hoveredItem === `resources-${item.label}` ? '#fff' : '#222', background: hoveredItem === `resources-${item.label}` ? '#0078d7' : 'transparent', borderRadius: '6px', margin: '0 8px', padding: '12px 16px' }}
                        onMouseEnter={() => setHoveredItem(`resources-${item.label}`)}
                        onMouseLeave={() => setHoveredItem(null)}>{item.label}</a>
                    </li>
                  ))}
                </ul>
              )}
            </li>

            {/* Company dropdown */}
            <li style={styles.navItem}>
              <a href="#company"
                style={{ ...styles.navLink, color: openDropdown === 'company' ? '#0078d7' : '#222' }}
                onClick={(e) => { e.preventDefault(); toggleDropdown('company'); }}>
                Company <i className="fas fa-caret-down"></i>
              </a>
              {openDropdown === 'company' && (
                <ul style={{ ...styles.dropdownContent, listStyle: 'none', padding: '8px 0', margin: 0 }}>
                  {dropdowns.company.map(item => (
                    <li key={item.label}>
                      <a href={item.href}
                        style={{ ...styles.dropdownLink, color: hoveredItem === `company-${item.label}` ? '#fff' : '#222', background: hoveredItem === `company-${item.label}` ? '#0078d7' : 'transparent', borderRadius: '6px', margin: '0 8px', padding: '12px 16px' }}
                        onMouseEnter={() => setHoveredItem(`company-${item.label}`)}
                        onMouseLeave={() => setHoveredItem(null)}>{item.label}</a>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          </ul>
        </nav>
      </header>

      {/* Hero Section */}
      <div id="home" style={styles.hero}>
        <h1 style={{ fontSize: '32px', fontWeight: '700', margin: '0 0 12px 0' }}>Welcome to Astravision</h1>
        <p style={{ fontSize: '16px', margin: '0 0 20px 0', lineHeight: '1.6' }}>Cloud-powered software for modern organizations.<br />
          Discover our suite of products designed to simplify your business operations.</p>
        <button style={styles.ctaBtn} onClick={() => window.location.reload()}>Get Started</button>
        <br />
        <img
          src="https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&w=600&q=80"
          alt="Cloud Tech"
          style={styles.heroImg}
        />
      </div>

      {/* Products Section */}
      <section id="products" style={styles.productsSection}>
        <div style={styles.productCard} onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-8px) scale(1.03)'} onMouseLeave={e => e.currentTarget.style.transform = 'none'}>
          <i className="fas fa-school" style={styles.productIcon}></i>
          <img src="https://img.icons8.com/ios-filled/200/000000/school.png" alt="School Management" style={styles.productImg} />
          <h3>School Management System</h3>
          <p>Manage students, staff, classes, and academic records efficiently. Used by schools and colleges for digital transformation.</p>
          <button style={styles.productBtn} onClick={() => navigate('/school-management')}>Learn More</button>
        </div>
        <div style={styles.productCard} onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-8px) scale(1.03)'} onMouseLeave={e => e.currentTarget.style.transform = 'none'}>
          <i className="fas fa-warehouse" style={styles.productIcon}></i>
          <img src="https://img.icons8.com/ios-filled/200/000000/warehouse.png" alt="Inventory Management" style={styles.productImg} />
          <h3>Inventory Management</h3>
          <p>Track inventory, manage stock levels, and automate supply chain processes. Ideal for retailers, warehouses, and distributors.</p>
          <button style={styles.productBtn}>Learn More</button>
        </div>
        <div style={styles.productCard} onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-8px) scale(1.03)'} onMouseLeave={e => e.currentTarget.style.transform = 'none'}>
          <i className="fas fa-users" style={styles.productIcon}></i>
          <img src="https://img.icons8.com/ios-filled/200/000000/conference-call.png" alt="HR & Payroll" style={styles.productImg} />
          <h3>HR &amp; Payroll Solution</h3>
          <p>Handle employee records, payroll, and HR tasks with ease and accuracy. Perfect for businesses of all sizes.</p>
          <button style={styles.productBtn}>Learn More</button>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" style={styles.featuresSection}>
        <h2>Why Choose Astravision?</h2>
        <div style={styles.featuresList}>
          <ul style={styles.featuresUl}>
            <li style={styles.featuresLi}><i className="fas fa-cloud" style={{ color: '#0078d7', marginRight: '8px' }}></i> 100% Cloud-Based &amp; Secure</li>
            <li style={styles.featuresLi}><i className="fas fa-bolt" style={{ color: '#0078d7', marginRight: '8px' }}></i> Fast &amp; Reliable Performance</li>
            <li style={styles.featuresLi}><i className="fas fa-cogs" style={{ color: '#0078d7', marginRight: '8px' }}></i> Easy Integration</li>
          </ul>
          <ul style={styles.featuresUl}>
            <li style={styles.featuresLi}><i className="fas fa-users-cog" style={{ color: '#0078d7', marginRight: '8px' }}></i> User-Friendly Interface</li>
            <li style={styles.featuresLi}><i className="fas fa-chart-line" style={{ color: '#0078d7', marginRight: '8px' }}></i> Real-Time Analytics</li>
            <li style={styles.featuresLi}><i className="fas fa-headset" style={{ color: '#0078d7', marginRight: '8px' }}></i> 24/7 Support</li>
          </ul>
        </div>
      </section>

      {/* How It Works Section */}
      <section id="how" style={styles.howSection}>
        <h2>How It Works</h2>
        <div style={styles.steps}>
          <div style={styles.step}>
            <i className="fas fa-user-plus" style={styles.stepIcon}></i>
            <h4>Sign Up</h4>
            <p>Create your Astravision account in minutes.</p>
          </div>
          <div style={styles.step}>
            <i className="fas fa-sliders-h" style={styles.stepIcon}></i>
            <h4>Choose Product</h4>
            <p>Select the solution that fits your needs.</p>
          </div>
          <div style={styles.step}>
            <i className="fas fa-rocket" style={styles.stepIcon}></i>
            <h4>Get Started</h4>
            <p>Launch and manage your business with ease!</p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer id="contact" style={styles.footer}>
        &copy; 2026 Astravision Softech Pvt. Ltd. | Contact: info@astravision.net
      </footer>
    </div>
  );
}

export default AstravisionDemo;
